import FIKA from "assets/images/icons/fika-icon.svg";
import TRENT from "assets/images/icons/trent-icon.svg";
import GENERICO from "assets/images/icons/generico-icon.svg";
import SINASIGNAR from "assets/images/icons/sinAsignar-icon.svg";
import FEMMTO from "assets/images/icons/femmto-icon.svg";
import styled from "@emotion/styled";
import { Switch } from "@mui/material";

export const COLUMNS_TO_FILTER = [
  { data: "campaignName", label: "Campaña" },
  { data: "graph", label: "Gráfica" },
  { data: "adState", label: "Ad State" },
  { data: "dailyBudget", label: "Presupuesto Diario" },
  { data: "targetRoas", label: "ROAS objetivo" },
  { data: "gapConsumed", label: "% GAP consumido mensual" },
  { data: "dailygapconsumed", label: "% GAP consumido diario" },
  { data: "cpc", label: "CPC" },
  { data: "cvr", label: "CVR" },
  { data: "salesContribution", label: "Contribución de ventas" },
  { data: "roas", label: "ROAS" },
  { data: "acos", label: "ACOS" },
  { data: "recommendation", label: "Recomendación" },
];

export const INITIAL_COLUMNS_STATE = {
  campaignName: true,
  graph: true,
  adState: true,
  dailyBudget: true,
  targetRoas: true,
  gapConsumed: true,
  dailygapconsumed: true,
  cpc: true,
  cvr: true,
  salesContribution: true,
  roas: true,
  acos: true,
  recommendation: true,
};

export const INITIAL_AD_STATE = [
  { data: "NPI", label: "NPI" },
  { data: "Early Stage", label: "Early Stage" },
  { data: "High Growth", label: "High Growth" },
  { data: "Profitable Core", label: "Profitable Core" },
  { data: "Exit", label: "Exit" },
];

export const brandIcons = {
  FIKA: FIKA,
  TRENT: TRENT,
  GENERICO: GENERICO,
  "SIN ASIGNAR": SINASIGNAR,
  FEMMTO: FEMMTO,
};

export const COLUMNS_TO_FILTER_ADS = [
  { data: "pictureUrl", label: "Foto" },
  { data: "title", label: "Producto" },
  { data: "variants", label: "Variantes" },
  { data: "stock", label: "Stock" },
  { data: "impressions", label: "Impresiones" },
  { data: "ctr", label: "CTR" },
  { data: "clicks", label: "Clics" },
  { data: "cpc", label: "CPC" },
  { data: "cvr", label: "CVR" },
  { data: "roas", label: "ROAS" },
  { data: "contributionSales", label: "Contribución de ventas" },
  { data: "revenue", label: "Ingresos" },
  { data: "cost", label: "Inversión" },
  { data: "acos", label: "ACOS" },
  { data: "tacos", label: "TACOS" },
];

export const INITIAL_COLUMNS_STATE_ADS = {
  pictureUrl: true,
  title: true,
  variants: true,
  stock: true,
  impressions: true,
  ctr: true,
  clicks: true,
  cpc: true,
  cvr: true,
  roas: true,
  contributionSales: true,
  revenue: true,
  cost: true,
  acos: true,
  tacos: true,
};

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      color: "#354887", // color del switch cuando está encendido
      "& + .MuiSwitch-track": {
        backgroundColor: "#9aa3c3", // color del cuerpo cuando está encendido
      },
    },
  },
}));
